import './graphStyles.css'

const CustomGraphTooltip = ({ active, payload, label }) => {
  if (active && payload && payload?.length) {
    return (
      <div className='graph-tooltip-container'>
        <span className='graph-tooltip-heading'>{label}</span>
        {payload?.map((payloadItem, index) => {
          return (
            <div
              key={`${payloadItem?.name}${index}`}
              className='graph-tooltip-data-container'
            >
              <span className='graph-tooltip-title'>{payloadItem?.name}</span>
              <span>&nbsp;:&nbsp;</span>
              <span className='graph-tooltip-value'>{payloadItem?.value}</span>
            </div>
          )
        })}
      </div>
    )
  }

  return null
}

export default CustomGraphTooltip
